import type { AdvisoryDraftStatus } from "@/lib/cosmos-api";

/** Mirrors the Advisory Master-Doc workflow statuses. */
export const DRAFT_STATUS_LABELS: Record<AdvisoryDraftStatus, string> = {
  not_planned: "Not planned yet",
  planned: "Planned",
  blocked: "Blocked",
  in_progress: "In progress",
  done: "Done"
};

export const DRAFT_STATUS_TONES: Record<
  AdvisoryDraftStatus,
  "neutral" | "info" | "danger" | "azure" | "success"
> = {
  not_planned: "neutral",
  planned: "info",
  blocked: "danger",
  in_progress: "azure",
  done: "success"
};
